import gql from 'graphql-tag'

export const GET_RECORDINGS = gql`
  query getRecordings($provider: String!, $roomId: String, $endDate: Float, $startDate: Float, $page: Float) {
    recordings(provider: $provider, roomId: $roomId, endDate: $endDate, startDate: $startDate, page: $page) {
      count
      nextPage
      recordings {
        url
        startDate
        endDate
        title
      }
    }
  }
`
